

export const ErrorCodes = {
	OK: 'OK',
	UNKNOWN: 'UNKNOWN',
	UNCLASSIFIED_ERROR: 'UNCLASSIFIED_ERROR',
	REGISTRATION_FAIL_CONTACT_EXISTS: 'REGISTRATION_FAIL_CONTACT_EXISTS',
	INVALID_LOGIN: 'INVALID_LOGIN',
	ACCOUNT_NOT_FOUND: 'ACCOUNT_NOT_FOUND',
	NOTFOUNDEXCEPTION: 'NOTFOUNDEXCEPTION',
	EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
	INVALID_PASSWORD_EXCEPTION: 'INVALID_PASSWORD_EXCEPTION',
	PASSWORD_LENGTH_EXCEPTION: 'PASSWORD_LENGTH_EXCEPTION',
	PAYMENT_GATEWAY_EXCEPTION: 'PAYMENT_GATEWAY_EXCEPTION',
	CUSTOMER_EMAIL_ALREADY_EXIST: 'CUSTOMER_EMAIL_ALREADY_EXIST',
	TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS",
	TOO_MANY_RECIPIENTS_EXCEPTION: "TOO_MANY_RECIPIENTS_EXCEPTION",
	INVALIDVALUEEXCEPTION: "INVALIDVALUEEXCEPTION",
	CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION: "CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION",
	CANNOTEXECUTESUBSCRIPTIONACTIONEXCEPTION: "CANNOTEXECUTESUBSCRIPTIONACTIONEXCEPTION",
}

export function createResult(errorCode, data) {
	return {
		code: errorCode,
		data: data
	}
}

export function createCommonResult(response, requestType) {
	console.log("11111 response:", response);
	if (response.code == 'OK' || response.code == '204')
		return createResult(ErrorCodes.OK, response.data);
	else if (response.code == '429') {
		return createResult(ErrorCodes.TOO_MANY_REQUESTS, response.error);
	} else if (response.error && response.error.error == "CRM.EXCEPTIONS.INVALIDVALUEEXCEPTION") {
		return createResult(ErrorCodes.INVALIDVALUEEXCEPTION, response.error)
	} else if (response.error && response.error.error == "CRM.EXCEPTIONS.ALREADYEXISTSEXCEPTION") {
		return createResult(ErrorCodes.CUSTOMER_EMAIL_ALREADY_EXIST, response.error)
	} else if (response.error && response.error.error == "CRM.EXCEPTIONS.NOTFOUNDEXCEPTION") {
		return createResult(ErrorCodes.NOTFOUNDEXCEPTION, response.error)
	} else if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION") {
		return createResult(ErrorCodes.CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION, response.error)
	} else if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.CANNOTEXECUTESUBSCRIPTIONACTIONEXCEPTION") {
		return createResult(ErrorCodes.CANNOTEXECUTESUBSCRIPTIONACTIONEXCEPTION, response.error)
	}
	else {
		return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
	}
}